// get_host_request
export const GET_DELETE_REQUEST = "GET_DELETE_REQUEST";

// handle host request accept 
export const ACCEPT_DELETE_REQUEST = "ACCEPT_DELETE_REQUEST";